<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_ix">PERSUASION, REFLECTION, JUDGMENT</a></p><a id="page_ix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm02.vue?2ef74ae8